<!-- @format -->
<template>
    <div class="container">
        <content-not-found reason="pageNotFound" :render-direct="true" />
    </div>
</template>

<script>
import ContentNotFound from '@/components/Content/NotFound/ContentNotFound.vue';

export default {
    metaInfo: {
        meta: [{ name: 'robots', content: 'none' }]
    },

    components: {
        ContentNotFound
    }
};
</script>
